import { ofType, Epic, combineEpics } from "redux-observable";
import { catchError, map, merge, mergeMap, of, takeUntil } from "rxjs";
import { selectAuthTokens } from "../../../features/auth/selectors/auth.selector";
import { categoriesActions } from "../../../features/categories/redux";
import { countriesActions } from "../../../features/countries/redux";
import { dataFieldsActions } from "../../../features/data-fields/redux";
import { naicsCodesActions } from "../../../features/naics-codes/redux";
import { sicCodesActions } from "../../../features/sic-codes/redux";
import { statesActions } from "../../../features/states/redux";
import { IAction } from "../../../interface/action.interface";
import { IErrorDto } from "../../../interface/dto/error.dto";
import { IRootState } from "../../../redux/root.reducer";
import { selectListBuilderFiltersAndPagination } from "../../list-builder-table/selectors/filters-and-pagination";
import {
    fetchListBuilderDetails,
    saveListBuilder,
    updateListBuilder,
} from "../service/list-builder-form-page.api";
import {
    ListBuilderActionType,
    listBuilderGetDetailsSuccessAction,
    listBuilderGetDetailsErrorAction,
    listBuilderSaveSuccessAction,
    listBuilderSaveErrorAction,
    IListBuilderActions,
} from "./list-builder-form-page.action";
import { listBuilderListInitAction } from "./list-builder-list.actions";
import { listBuilderListEpic } from "./list-builder-list.epic";

export const listBuilderEpic: Epic<IAction, IAction, IRootState> = (
    action$,
    state$,
) =>
    merge(
        action$.pipe(
            ofType<
                IListBuilderActions,
                ListBuilderActionType.LIST_BUILDER_INIT
            >(ListBuilderActionType.LIST_BUILDER_INIT),
            mergeMap(() => [
                listBuilderListInitAction(),
                statesActions.init(),
                naicsCodesActions.init(),
                sicCodesActions.init(),
                countriesActions.init(),
                dataFieldsActions.init(),
                categoriesActions.init(),
            ]),
        ),

        action$.pipe(
            ofType<
                IListBuilderActions,
                ListBuilderActionType.LIST_BUILDER_GET_DETAILS
            >(ListBuilderActionType.LIST_BUILDER_GET_DETAILS),
            mergeMap((action) =>
                fetchListBuilderDetails(
                    action.payload.listBuilderId,
                    selectAuthTokens(),
                    selectListBuilderFiltersAndPagination(state$.value).email,
                ).pipe(
                    takeUntil(
                        action$.pipe(
                            ofType(
                                ListBuilderActionType.LIST_BUILDER_GET_DETAILS,
                            ),
                        ),
                    ),
                    map(listBuilderGetDetailsSuccessAction),
                    catchError((error: IErrorDto) =>
                        of(listBuilderGetDetailsErrorAction(error.message)),
                    ),
                ),
            ),
        ),

        action$.pipe(
            ofType<
                IListBuilderActions,
                ListBuilderActionType.LIST_BUILDER_SAVE
            >(ListBuilderActionType.LIST_BUILDER_SAVE),
            mergeMap((action) =>
                (action.payload.listBuilderId
                    ? updateListBuilder(
                          action.payload.listBuilderId,
                          action.payload.listBuilder,
                          selectAuthTokens(),
                          action.payload.run,
                          selectListBuilderFiltersAndPagination(state$.value)
                              .email,
                      )
                    : saveListBuilder(
                          action.payload.listBuilder,
                          selectAuthTokens(),
                          action.payload.run,
                          selectListBuilderFiltersAndPagination(state$.value)
                              .email,
                      )
                ).pipe(
                    map(listBuilderSaveSuccessAction),
                    catchError((error: IErrorDto) =>
                        of(listBuilderSaveErrorAction(error)),
                    ),
                ),
            ),
        ),
    );

export const listBuilderPageEpic = combineEpics<IAction, IAction, IRootState>(
    listBuilderEpic,
    listBuilderListEpic,
);
